import gql from 'graphql-tag'

export default {
  data () {
    return {
      searchedUsers: [],
      query: '',
    }
  },

  computed: {
    getSearchedUsers () {
      return this.searchedUsers.map(u => u.object)
    }
  },


  // Apollo...
  apollo: {
    searchResult: {
      query: gql`query ($query: String!, $type: [SearchDocType!], $limit: Int!, $offset: Int!) {
        searchResult: search(query: $query, type: $type, limit: $limit, offset: $offset){
          info {
            total,
            limit,
            offset
          },
          set{
            id,
            type,
            label,
            object {
              ... on User {
                id,
                name,
                email,
                mediaPlanEvents {
                  info {
                    total
                  }
                },
                contact {
                  id: vatId,
                  companyName,
                  contactPerson,
                  phone,
                  vatId
                }
              },
            }
          }
        }
      }`,
      variables () {
        return {
          query: this.query,
          type: 'user',
          limit: this.limit,
          offset: this.getOffset,
        }
      },

      result (result) {
        if (result.loading) return
        let { data: { searchResult: { set, info } } } = result

        this.$set(this, 'searchedUsers', set)
        this.$set(this, 'info', info)
      },

      skip () {
        return !this.query
      },

      debounce: 500,
      fetchPolicy: 'cache-and-network'
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/searchUsers.js